export default __webpack_public_path__ + "static/media/32899202_442517482867535_7576480678473105408_o_442517476200869.61b3e93b.jpg";